import { type ProductizedServiceMoreCard_productizedService$key } from '#app/__generated__/relay/ProductizedServiceMoreCard_productizedService.graphql.js';
import { Link } from '#app/components/Link/index.js';
import { ProductizedServiceCardDetails } from './ProductizedServiceCardDetails.js';
import { ProductizedServiceCardPrice } from './ProductizedServiceCardPrice.js';
import { graphql, useFragment } from '@contra/relay';
import { getRoute } from '@contra/routes';
import { styled } from 'styled-components';

const Container = styled(Link)`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    gap: 24px;
    border: 1px solid ${theme.colors.gray30};
    border-radius: 16px;
    padding: 24px;
    transition: box-shadow 125ms ease-in-out;

    :hover {
      box-shadow: ${theme.boxShadowV2.basic20};
    }

    ${theme.mediaQueries.lg} {
      padding: 0;
      flex-direction: row;
      gap: 0;

      > *:first-child {
        border-right: 1px solid ${theme.colors.gray30};
        flex-grow: 1;
      }

      > *:last-child {
        width: 216px;
      }
    }
  `}
`;

type ProductizedServiceMoreCardProps = {
  readonly productizedServiceRef: ProductizedServiceMoreCard_productizedService$key;
};

export const ProductizedServiceMoreCard = ({
  productizedServiceRef,
}: ProductizedServiceMoreCardProps) => {
  const service =
    useFragment<ProductizedServiceMoreCard_productizedService$key>(
      graphql`
        fragment ProductizedServiceMoreCard_productizedService on ProductizedService {
          slug
          price {
            ...ProductizedServiceCardPrice_price
          }
          ...ProductizedServiceCardDetails_productizedService
        }
      `,
      productizedServiceRef,
    );

  return (
    <Container to={getRoute('/s/@slug', { args: { slug: service.slug } })}>
      <ProductizedServiceCardDetails productizedServiceRef={service} />
      <ProductizedServiceCardPrice priceRef={service.price} />
    </Container>
  );
};
